// common/hooks/useStatusBar.ts
import { useMemo } from 'react'
import { differenceInCalendarDays, format } from 'date-fns'
import { ClusterInterface } from '../../types/interfaces'

const getPaymentIssues = (clusters: ClusterInterface[]) => {
  if (clusters.length === 0) {
    return { issues: [], status: 'ok' as const, message: '' }
  }

  const issues = clusters.filter((cluster) => {
    const tariff = cluster.tariff
    const hasPaidTariff = tariff && tariff.isActive && (tariff.basePrice > 0 || (tariff.specialPrice ?? 0) > 0)
    if (!hasPaidTariff) return false
    if (!cluster.billing?.paidUntil) return false

    const daysLeft = differenceInCalendarDays(new Date(cluster.billing.paidUntil), new Date())
    return daysLeft < 7
  })

  if (issues.length === 0) {
    return { issues: [], status: 'ok' as const, message: '' }
  }

  const sorted = [...issues].sort((a, b) => {
    const dateA = a.billing?.paidUntil ? new Date(a.billing.paidUntil).getTime() : 0
    const dateB = b.billing?.paidUntil ? new Date(b.billing.paidUntil).getTime() : 0
    return dateA - dateB
  })

  const cluster = sorted[0]
  const daysLeft = differenceInCalendarDays(new Date(cluster.billing!.paidUntil!), new Date())
  const extraCount = sorted.length - 1

  const status = daysLeft <= 0 || daysLeft <= 3 ? 'error' : 'warning'

  let msg = ''
  if (daysLeft <= 0) {
    msg = `Оплатите "${cluster.name}" — доступ ограничен`
  } else if (extraCount > 0) {
    msg = `Оплатите ${sorted.length} кластера. "${cluster.name}" — ${daysLeft} дн. до блокировки (${format(new Date(cluster.billing!.paidUntil!), 'dd.MM.yyyy')})`
  } else {
    msg = `Оплатите "${cluster.name}" — ${daysLeft} дн. до блокировки (${format(new Date(cluster.billing!.paidUntil!), 'dd.MM.yyyy')})`
  }

  return { issues, status, message: msg }
}

export const useStatusBar = (clusters: ClusterInterface[]) => {
  const { issues, status, message } = useMemo(
    () => getPaymentIssues(clusters),
    [clusters]
  )

  return { paymentIssues: issues, status, message }
}